import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BackpackModule } from 'app/backpack/backpack.module';
import { CoreModule } from '../../core/core.module';
import { TimeInputComponent } from './time-input/time-input.component';
import { TimeRangeInputComponent } from './time-range-input/time-range-input.component';

@NgModule({
	declarations: [TimeRangeInputComponent, TimeInputComponent],
	exports: [TimeRangeInputComponent],
	imports: [CommonModule, CoreModule, FormsModule, ReactiveFormsModule, BackpackModule],
})
export class TimeRangeInputModule {}
